import UnavailabilityConfigContainer from './UnavailabilityConfigContainer'

export default function UnavailabilityConfigScreen() {
    return <UnavailabilityConfigContainer />
}
